<template>
  <div class="formkit-inner barcode-inner barcode-input" :class="barcodeClass">
     <span  class="pl-1">
       <font-awesome-icon
           icon="barcode"
           size="1x"
           title="barcode"
       >
       </font-awesome-icon>
     </span>
    <input
        type="text"
        :action="barcodeAction"
        :id="barcodeId"
        @input="this.$emit('update:modelValue', $event.target.value)"
        class="formkit-input barcode-input "
        v-focus
        autocomplete="off"
    >
    <span class="pr-1">
      <font-awesome-icon
          icon="search"
          size="1x"
          title="search"
      >
       </font-awesome-icon>
    </span>
    <p class="epos-barcode-scanner-status">{{barcodeMessage}}</p>
  </div>
</template>

<script>

export default {
  name: 'BarcodeScanner',
  props: {
    barcodeMessage: {
      type: String,
      default: ''
    },
    barcodeAction: {
      type: String,
      default: ''
    },
    barcodeClass: {
      type: String,
      default: ''
    },
    barcodeId: {
      type: String,
      default: ''
    },
    barcode: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
};
</script>

<style scoped>
.formkit-input.barcode-input {
  width: 85%;
  display: inline-block;
}

.epos-barcode-scanner-status {
  font-weight: bold;
}
</style>